// Соответствия студентов кабинета студентам eljur

export const ADD_CONFORM = 'eljur/ADD_CONFORM';

export const addConform = payload => ({
  type: ADD_CONFORM,
  payload,
});
